export function deleteDeposit(data) {
    let { deleteDepositRequest, deleteDepositError, deleteDepositResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/deposit/delete',
        this.createBundle('app/deposit/delete', { deposit: data }, this.POST, deleteDepositRequest, deleteDepositResult, deleteDepositError)
    )
}
